<template>
  <!-- Table Container Card -->
  <b-card no-body>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <!-- <label>Entries</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          /> -->
          <b-button
            v-if="employeeData"
            v-b-modal.modal-login
            size="lg"
            variant="primary"
          >
            Show Payroll
          </b-button>
          <!-- @click="searchQuery = employeeData.employee_no" -->
          <!-- :to="{ name: 'apps-payroll-add'}" -->
        </b-col>

        <!-- Search -->
        <b-col cols="12" md="6">
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-if="!employeeData"
              v-model="searchQuery"
              class="d-inline-block mr-1"
              placeholder="Search..."
            />
            <!-- <v-select
              v-model="statusFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOptions"
              class="payroll-filter-select"
              placeholder="Select Status"
            >
              <template #selected-option="{ label }">
                <span class="text-truncate overflow-hidden">
                  {{ label }}
                </span>
              </template>
            </v-select> -->
          </div>
        </b-col>
      </b-row>
      <!-- modal login-->
      <b-modal
        id="modal-login"
        cancel-variant="outline-secondary"
        ok-title="Ok"
        cancel-title="Close"
        centered
        title="Input Password"
        @ok="handleOk"
      >
        <b-form>
          <!-- <b-form-group>
            <label for="email">Email:</label>
            <b-form-input
              id="email"
              type="email"
              placeholder="Email Address"
            />
          </b-form-group> -->
          <b-form-group>
            <label for="password">Password</label>
            <b-form-input
              v-model="passwrd"
              type="password"
              placeholder="Birthdate format yyyy-mm-dd"
            />
            <!-- Birthdate format yyyy-mm-dd -->
            <!-- Middle name -->
          </b-form-group>
        </b-form>
      </b-modal>
    </div>

    <b-table
      ref="refPayrollListTable"
      :items="fetchPayrolls"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      empty-text="No matching records found"
      :sort-desc.sync="isSortDirDesc"
      class="position-relative"
    >
      <template #head(payrollStatus)>
        <feather-icon icon="TrendingUpIcon" class="mx-auto" />
      </template>

      <template #cell(pay_period)="data">
        <b-link
          :to="{ name: 'apps-payroll-preview', params: { id: data.item.id } }"
          class="font-weight-bold"
        >
          {{ data.value }}
        </b-link>
      </template>

      <!-- Column: Id -->
      <!-- <template #cell(id)="data">
        <b-link
          :to="{ name: 'apps-payroll-preview', params: { id: data.item.id }}"
          class="font-weight-bold"
        >
          #{{ data.value }}
        </b-link>
      </template> -->

      <!-- Column: Payroll Status -->
      <!-- <template #cell(payrollStatus)="data">
        <b-avatar
          :id="`payroll-row-${data.item.id}`"
          size="32"
          :variant="`light-${resolvePayrollStatusVariantAndIcon(data.item.payrollStatus).variant}`"
        >
          <feather-icon
            :icon="resolvePayrollStatusVariantAndIcon(data.item.payrollStatus).icon"
          />
        </b-avatar>
        <b-tooltip
          :target="`payroll-row-${data.item.id}`"
          placement="top"
        >
          <p class="mb-0">
            {{ data.item.payrollStatus }}
          </p>
          <p class="mb-0">
            Balance: {{ data.item.balance }}
          </p>
        </b-tooltip>
      </template> -->

      <!-- Column: Client -->
      <template #cell(client)="data">
        <b-media vertical-align="center">
          <!-- <template #aside>
            <b-avatar
              size="32"
              :src="data.item.avatar"
              :text="avatarText(data.item.client.client_name)"
              :variant="`light-${resolveClientAvatarVariant(data.item.payrollStatus)}`"
            />
          </template> -->
          <span class="font-weight-bold d-block text-nowrap">
            {{ data.item.client_name }}
          </span>
          <small class="text-muted">{{
            data.item.employee_no + "-" + data.item.employee_name
          }}</small>
        </b-media>
      </template>

      <!-- Column: Issued Date -->
      <template #cell(total_deductions)="data">
        <span class="text-nowrap">
          {{ data.value }}
        </span>
      </template>

      <!-- Column: Balance -->
      <template #cell(net_pay)="data">
        <template v-if="data.value === 0">
          <b-badge pill variant="light-success"> Paid </b-badge>
        </template>
        <template v-else>
          {{ data.value }}
        </template>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <div class="text-nowrap">
          <feather-icon
            :id="`payroll-row-${data.item.id}-send-icon`"
            icon="SendIcon"
            class="cursor-pointer"
            size="16"
          />
          <b-tooltip
            title="Send Payroll"
            class="cursor-pointer"
            :target="`payroll-row-${data.item.id}-send-icon`"
          />

          <feather-icon
            :id="`payroll-row-${data.item.id}-preview-icon`"
            icon="EyeIcon"
            size="16"
            class="mx-1"
            @click="
              $router.push({
                name: 'apps-payroll-preview',
                params: { id: data.item.id },
              })
            "
          />
          <b-tooltip
            title="Preview Payroll"
            :target="`payroll-row-${data.item.id}-preview-icon`"
          />

          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item>
              <feather-icon icon="DownloadIcon" />
              <span class="align-middle ml-50">Download</span>
            </b-dropdown-item>
            <!-- <b-dropdown-item :to="{ name: 'apps-payroll-edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item> -->
            <b-dropdown-item>
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
            <!-- <b-dropdown-item>
              <feather-icon icon="CopyIcon" />
              <span class="align-middle ml-50">Duplicate</span>
            </b-dropdown-item> -->
          </b-dropdown>
        </div>
      </template>
    </b-table>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted"
            >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
            {{ dataMeta.of }} entries</span
          >
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalPayrolls"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
  BForm,
  BFormGroup,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import vSelect from "vue-select";
import { onUnmounted } from "@vue/composition-api";
import store from "@/store";
import usePayrollList from "./usePayrollList";

import payrollStoreModule from "../payrollStoreModule";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BModal,
    BForm,
    BFormGroup,
    vSelect,
  },
  props: {
    employeeData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      passwrd: "",
      birthdate: "",
    };
  },
  methods: {
    handleOk() {
      if (this.passwrd === this.employeeData.birth_date.toString().trim()) {
        this.searchQuery = this.employeeData.employee_no.trim();
      }
      // middle_name.trim()
      // birth_date.getFullYear().toString()
      // this.handleSubmit()
    },
    handleSubmit() {
      // searchQuery = employeeData.employee_no
      this.$bvModal.close();
    },
  },
  setup() {
    const PAYROLL_APP_STORE_MODULE_NAME = "app-payroll";

    // Register module
    if (!store.hasModule(PAYROLL_APP_STORE_MODULE_NAME))
      store.registerModule(PAYROLL_APP_STORE_MODULE_NAME, payrollStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PAYROLL_APP_STORE_MODULE_NAME))
        store.unregisterModule(PAYROLL_APP_STORE_MODULE_NAME);
    });

    const statusOptions = [
      "Downloaded",
      "Draft",
      "Paid",
      "Partial Payment",
      "Past Due",
    ];

    const {
      fetchPayrolls,
      tableColumns,
      perPage,
      currentPage,
      totalPayrolls,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPayrollListTable,

      statusFilter,

      refetchData,

      resolvePayrollStatusVariantAndIcon,
      resolveClientAvatarVariant,
    } = usePayrollList();

    return {
      fetchPayrolls,
      tableColumns,
      perPage,
      currentPage,
      totalPayrolls,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPayrollListTable,

      statusFilter,

      refetchData,

      statusOptions,

      avatarText,
      resolvePayrollStatusVariantAndIcon,
      resolveClientAvatarVariant,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.payroll-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
